<template lang="pug">
  ul.user-team-table(
    :style="{'grid-template-columns': gridLayout}"
  )
    li.user-team-table__cell.-body-
      .user-team-person
        .user-team-person__img-wrapper
          img(
            :src="user.avatar || defaultAvatar"
            alt=""
          ).user-team-person__img
          Icon.user-team-person__img-icon(
            v-if="user.id === leader"
            icon="ui-star-volume"
          )

        .user-team-person__info
          p.user-team-person__name
            | {{userName}}
            //- Иконка с типом пользователя
            //- решили выпилить, но может ещё пригодится
            //- Icon.user-team-person__icon(
            //-   v-if="typeIcon"
            //-   :icon="typeIcon"
            //- )
          p.user-team-person__city {{user.city || 'Город не указан'}}


    li.user-team-table__cell.-body-
      a.user-team-table__link(
        v-if="userNickName"
        :href="`https://t.me/${user.username}`"
        target="_blank"
      )
        | {{userNickName}}
    li.user-team-table__cell.-body-(
      v-if="showEmail"
    )
      p.user-team-table__link(
        @click="copyText(user.email)"
      )
        | {{user.email}}

    template(
      v-if="!isSmart"
    )
      li.user-team-table__cell.-body-(
        v-if="showFaculty"
      )
        | {{user.faculty}}

      li.user-team-table__cell.-body-
        | {{user.lessonsAvailable}}

      li.user-team-table__cell.-body-
        | {{user.lessonsCompleted}}

      li.user-team-table__cell.-body-
        | {{user.lessonsPassed}}
    li.user-team-table__cell.-body-(
      v-if="showGroupName"
    )
      | {{groupName}}
    li.user-team-table__cell.-body-(
      v-if="isFaculty"
    )
      | {{user.faculty}}
    li.user-team-table__cell.-body-.user-team__icon-wrapper(
      v-if="canChangeTeam || canSetLeader"
      :class="{'-center-': actionCount === 1}"
    )
      template(v-if="canChangeTeam && showVerification")
        .user-team__progress(v-if="isLoadingVerification")
        Icon.user-team__icon.user-team__icon-access(
          v-else
          icon="on"
          :class="{'-active-': user.verified}"
          @click="setVerification"
          v-tooltip="{ content: user.verified ? 'Участник прошел верификацию' : 'Подтвердить верификацию', trigger: 'hover' }"
        )
      Icon.user-team__icon.user-team__icon--hover-accent(
        v-if="canChangeTeam && !authUser.isCaptain"
        icon="ui-update"
        :class="{'-active-': false}"
        @click.stop="showToggleFacultyModal"
      )
      Icon.user-team__icon.user-team__icon--hover-accent(
        v-if="canChangeTeam && !authUser.isCaptain"
        icon="ui-different-arrow"
        :class="{'-active-': false}"
        @click.stop="showToggleCourseModal"
      )
      Icon.user-team__icon.user-team__icon--hover-accent(
        v-if="canChangeTeam && !authUser.isCaptain"
        icon="ui-team"
        :class="{'-active-': false}"
        @click.stop="setGroup"
      )
      Icon.user-team__icon(
        v-if="canSetLeader && !authUser.isCaptain"
        icon="ui-star"
        :class="{'-active-': user.id === leader, 'user-team__icon--hover-warning': !disabledLeader}"
        @click.stop="setLeader"
      )
      Icon.user-team__icon.user-team__icon--hover-danger(
        v-if="canChangeTeam && canDeleteUser && !authUser.isCaptain"
        icon="delete"
        @click.stop="showDeleteModal"
      )
    UiModal(
      v-model="isOpenDeleteModal"
      :destroy="true"
      @reject="unshowDeleteModal"
      @accept="removeUserFromTeam"
      :loadingAccept="isLoadingRemove"
    )
      p Ты действительно хочешь удалить участника из команды?
    ToggleCourseModal(
      v-model="isOpenToggleCourseModal"
      :userId="user.id"
      @updateCourse="removeUserFromTeam"
    )
    ToggleFacultyModal(
      v-model="isOpenToggleFacultyModal"
      :userId="user.id"
      @updateUser="getTeam"
    )
</template>

<script>
import { mapState } from 'vuex';

import ToggleCourseModal from './ToggleCourseModal';
import ToggleFacultyModal from './ToggleFacultyModal';

export default {
  components: {
    ToggleCourseModal,
    ToggleFacultyModal
  },
  props: {
    gridLayout: {
      type: String,
      default: ''
    },
    user: {},
    team: {
      type: Object,
      default: () => ({})
    },
    leader: {},
    isSmart: {
      type: Boolean,
      default: false
    },
    isFaculty: {
      type: Boolean,
      default: false
    },
    canSetLeader: {
      type: Boolean,
      default: true
    },
    canChangeTeam: {
      type: Boolean,
      default: true
    },
    canDeleteUser: {
      type: Boolean,
      default: false
    },
    folderId: {},
    showGroupName: {
      type: Boolean,
      default: false
    },
    disabledLeader: {
      type: Boolean,
      default: false
    },
    showEmail: {
      type: Boolean,
      default: false
    },
    showFaculty: {
      type: Boolean,
      default: true
    },
    showVerification: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    defaultAvatar: '/lms/img/user-default.jpg',
    isOpenDeleteModal: false,
    isLoadingRemove: false,
    isOpenToggleCourseModal: false,
    isOpenToggleFacultyModal: false,
    isLoadingVerification: false
  }),
  computed: {
    ...mapState('teamGroup', {
      groupFolders: s => s.data.settings.groupFolders
    }),
    ...mapState('auth', {
      authUser: s => s.data.user
    }),
    userName() {
      if (this.user.name || this.user.lastname) {
        return `${this.user.name} ${this.user.lastname}`;
      }
      return 'Аноним';
    },
    userNickName() {
      return this.user.username ? `@${this.user.username}` : '';
    },
    // Иконка с типом пользователя
    // решили выпилить, но может ещё пригодится
    // typeIcon() {
    //   switch(this.user.type) {
    //     case 'normal':
    //       return 'ui-coin'
    //     case 'free':
    //       return 'ui-rabbit'
    //     case 'repeat':
    //       return 'ui-repeat'
    //     default:
    //       return null
    //   }
    // },
    actionCount() {
      return this.canSetLeader + this.canChangeTeam * 2 + this.canDeleteUser;
    },
    groupName() {
      return this.groupFolders[this.user.group];
    }
  },
  methods: {
    async setVerification() {
      this.isLoadingVerification = true;
      const state = await this.$store.dispatch('teamGroup/editVerification', this.user.id);
      if (state !== undefined) {
        this.isLoadingVerification = false;
      }
    },
    async setLeader() {
      if (this.disabledLeader) {
        return;
      }

      const backupLeader = this.leader;
      this.$emit('setLeader', this.user.id);

      const res = await this.$store.dispatch('teamGroup/editTeam', {
        id: this.team.id,
        leader: this.user.id
      });

      if (res.status !== 'success') {
        // что-то делать в случае ошибки
        this.$emit('setLeader', backupLeader);
      }
    },
    setGroup() {
      this.$store.dispatch('asides/addAside', {
        data: {
          name: 'distribution-team-group',
          title: 'Распределение в команду',
          subtitle: 'Добавьте или поменяйте команду для участника',
          slotClass: '-field-',
          user: {
            id: this.user.id,
            name: this.userName,
            teamId: this.team.id,
            groupId: this.user.group,
            folderId: this.folderId
          }
        }
      });
    },
    async removeUserFromTeam() {
      this.isLoadingRemove = true;
      if (this.team.id !== undefined) {
        await this.$store.dispatch('teamGroup/removeUserFromTeam', {
          user: this.user.id,
          team: this.team.id
        });
      } else {
        this.$store.commit('teamGroup/clearGroup');
        await this.$store.dispatch('teamGroup/getUnallocated');
      }
      this.isLoadingRemove = false;
    },
    showDeleteModal() {
      this.isOpenDeleteModal = true;
    },
    unshowDeleteModal() {
      this.isOpenDeleteModal = false;
    },
    showToggleCourseModal() {
      this.isOpenToggleCourseModal = true;
    },
    unshowToggleCourseModal() {
      this.isOpenToggleCourseModal = false;
    },
    showToggleFacultyModal() {
      this.isOpenToggleFacultyModal = true;
    },
    unshowToggleFacultyModal() {
      this.isOpenToggleFacultyModal = false;
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$store.dispatch(
          'ajax/addMessage',
          { message: 'Текст скопирован', type: 'success' },
          { root: true }
        );
      } catch (err) {
        console.warn('Не удалось скопировать текст');
      }
    },
    getTeam() {
      if (this.team.id === undefined) {
        return;
      }
      this.$store.dispatch('teamGroup/getTeamsData', this.team.id);
    }
  }
};
</script>
